import './GalleryHead.scss';

import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { ICON_UI_CLOSE } from '@bwoty-web/ui-kit/icons';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { Icon, Tab, TabList, Tabs } from '@bwoty-web/ui-kit';

// import LayoutControls from '../layoutControls/LayoutControls';
// import DarkmodeButton from '../darkmodeButton/DarkmodeButton';
import { imageSections } from '../../../views/hotelInfo/sections/helper';
// import GlobeDarkmodeButton from '../darkmodeButton/GlobeDarkmodeButton';

const GalleryHead = ({
  heading,
  sectionNames,
  // darkmode,
  // setDarkmode,
  close,
  allAlbumImages,
  setAlbumImages,
  allLightboxImages,
  setLightboxImages,
  // design,
  // updateLayout,
  imageCategories,
  preselectedCategory,
  setPreselectedCategory,
}) => {
  const isGlobetrotter = useIsGlobetrotter();
  const showCategories = imageCategories.length > 2; // "all" and "video"

  const filterByCategory = (category) => {
    if (category.key === 'all') {
      setAlbumImages(allAlbumImages);
      setLightboxImages(allLightboxImages);
    } else {
      const includedImageCategories = imageSections[category.key];
      setAlbumImages(
        [...allAlbumImages].filter((image) =>
          includedImageCategories.some((el) => image.categories.includes(el)),
        ),
      );
      setLightboxImages(
        [...allLightboxImages].filter((image) =>
          includedImageCategories.some((el) => image.categories.includes(el)),
        ),
      );
    }
  };

  // Filter out categories with less than 3 images
  const categoriesToDisplay = imageCategories.filter(
    (category) => category.amount > 3,
  );
  const categoryIndex = categoriesToDisplay.findIndex(
    (cat) => cat.key === preselectedCategory,
  );
  const defaultIndex = categoryIndex > -1 ? categoryIndex : 0;

  useEffect(() => {
    if (preselectedCategory !== 'all' && categoryIndex > -1) {
      filterByCategory(categoriesToDisplay[defaultIndex]);
      setPreselectedCategory('all');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preselectedCategory]);

  return (
    <div className="gw-gallery__head">
      <div className="gw-gallery__top-bar">
        <span className="gw-gallery__top-bar-title">{heading}</span>
        <div className="gw-gallery__close-button-group">
          {/* {!isGlobetrotter && (
            <LayoutControls layout={design} setLayout={updateLayout} />
          )}
          {!isGlobetrotter && (
            <DarkmodeButton checked={darkmode} setDarkmode={setDarkmode} />
          )}
          {isGlobetrotter && (
            <GlobeDarkmodeButton checked={darkmode} setDarkmode={setDarkmode} />
          )} */}
          {close && (
            <button type="button" className="gw-gallery__close" onClick={close}>
              <Icon
                className="gw-gallery__close-icon"
                path={ICON_UI_CLOSE}
                size="s"
                sizeMobile="xs"
                alt="close gallery"
              />
            </button>
          )}
        </div>
      </div>
      {showCategories && (
        <div className="gw-gallery__categories-row">
          <Tabs
            defaultIndex={defaultIndex}
            onChange={(ix) => filterByCategory(categoriesToDisplay[ix])}
          >
            <TabList>
              {categoriesToDisplay.map((category) => (
                <Tab key={category.key} lowercased={!isGlobetrotter}>
                  <div className="gw-gallery__category-text">
                    {`${sectionNames[category.key]} (${category.amount})`}
                  </div>
                </Tab>
              ))}
            </TabList>
          </Tabs>
        </div>
      )}
    </div>
  );
};

GalleryHead.propTypes = {
  close: PropTypes.func,
  heading: PropTypes.string,
  sectionNames: PropTypes.shape(),
  // darkmode: PropTypes.bool,
  // setDarkmode: PropTypes.func,
  // design: PropTypes.number,
  // updateLayout: PropTypes.func,
  allAlbumImages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setAlbumImages: PropTypes.func.isRequired,
  allLightboxImages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setLightboxImages: PropTypes.func.isRequired,
  imageCategories: PropTypes.arrayOf(PropTypes.shape()),
  preselectedCategory: PropTypes.string,
  setPreselectedCategory: PropTypes.func,
};

GalleryHead.defaultProps = {
  close: undefined,
  heading: '',
  sectionNames: {},
  // design: 1,
  // updateLayout: () => null,
  // darkmode: false,
  // setDarkmode: undefined,
  imageCategories: [],
  preselectedCategory: 'all',
  setPreselectedCategory: () => null,
};

export default GalleryHead;
